import { IAMAccountCredentialsService } from "./iam-account-credentials.service";
import { IAMAccountService } from "./iam-account.service";
import { IAMAccountsService } from "./iam-accounts.service";

export { IAMAccountCredentialsService, IAMAccountService, IAMAccountsService };

export default [
  IAMAccountCredentialsService,
  IAMAccountService,
  IAMAccountsService
];
